module.exports = __webpack_public_path__ + "img/c9b8dea7626427ba7f9d74c65747715b.49af1b08.jpg";